import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthSliceState {
    isLoggedIn: Nullable<boolean>;
    accessToken: Nullable<string>;
    crmSignInForm: {
        isLoading: boolean;
        errorMessage: Nullable<string>;
    };
}

const initialState: AuthSliceState = {
    isLoggedIn: null,
    accessToken: null,
    crmSignInForm: {
        isLoading: false,
        errorMessage: null,
    },
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: (create) => ({
        doLogin: create.reducer((state, { payload }: PayloadAction<AuthSliceState['accessToken']>) => {
            state.accessToken = payload;
            state.isLoggedIn = true;
        }),
        doLogout: create.reducer((state) => {
            state.accessToken = null;
            state.isLoggedIn = false;
        }),
        updateToken: create.reducer((state, { payload }: PayloadAction<AuthSliceState['accessToken']>) => {
            state.accessToken = payload;
        }),

        crmSignInFetch: create.reducer((state) => {
            state.crmSignInForm.isLoading = true;
            state.crmSignInForm.errorMessage = null;
        }),
        crmSignInSucceed: create.reducer((state) => {
            state.crmSignInForm.isLoading = false;
        }),
        crmSignInFailed: create.reducer(
            (state, { payload }: PayloadAction<AuthSliceState['crmSignInForm']['errorMessage']>) => {
                state.crmSignInForm.isLoading = false;
                state.crmSignInForm.errorMessage = payload;
            },
        ),
        clearCRMSignIn: create.reducer((state) => {
            state.crmSignInForm.isLoading = false;
            state.crmSignInForm.errorMessage = null;
        }),
    }),
    selectors: {
        selectAuth: (auth) => auth,
        selectAuthAccessToken: (auth) => auth.accessToken,
        selectAuthIsLoggedIn: (auth) => auth.isLoggedIn,
        selectAuthCrmSignInForm: (auth) => auth.crmSignInForm,
    },
});

export const { doLogin, doLogout, updateToken, crmSignInFetch, crmSignInSucceed, crmSignInFailed, clearCRMSignIn } =
    authSlice.actions;
export const { selectAuth, selectAuthAccessToken, selectAuthIsLoggedIn, selectAuthCrmSignInForm } = authSlice.selectors;
